import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useCommunityPublicationFeedStore = defineSmartFeedPiniaStore("community-publication-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    feedUrl: "/publication/community/smart-feed",
  }),
});
